/* eslint-disable */
<template>
  <div class="home">
    <section id="main-user-data" class="main-user-data">
      <PreloaderComponent v-if="loading" />
    </section>
  </div>
</template>

<script>
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";

export default {
  // eslint-disable-next-line
  name: "HomeView",
  components: {PreloaderComponent},
  data: () => {
    return {
      errors: [],
      loading: false,
    };
  },
};
</script>

